module.exports = __webpack_public_path__ + "static/5-5149057d1b8aa5c53aa65322c8f715b2.gif";